import React, { useEffect, useState, useRef } from "react"
import {
  AddressMolecule,
  SelectInput,
  TextInput,
  UploadComponent
} from "../../../../../component/index.jsx"
import { Card, CardBody, CardHeader } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  resetUrlResponse,
  uploadAction,
  getDetailRegional,
  getListSubRegionalByRole, getListBaseBySubRegional
} from "../../../../../redux/actions/MasterDataAction.jsx"
import { useDispatch, useSelector } from "react-redux"
import { UploadIcon } from "../../../../../component/atoms/Icons/SVG/upload.jsx"
import { useFormikContext } from "formik"
import { FIELD_OFFICER_ROLE_ENUM, FO_UPLOAD_ENUM } from "../../../../../constants/StringConstant.js"
import { TextFieldAutoComplete } from "../../../../../component/template/GoogleMaterialExamples/inputs/TextFieldAutoComplete.jsx"
import { useParams } from "react-router"
import { useTranslation } from "react-i18next"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import { ROLE_ENUM } from "../../../../../constants/RoleConstants.js"
import { Skeleton } from "@material-ui/lab"

export const DataFo = ({ isReadOnly, onKeyDown }) => {
  const { values: formValues, setFieldValue } = useFormikContext()
  const { MasterData, FieldOfficer, General } = useSelector((state) => state)
  const user = loadUserLogin()
  const dispatch = useDispatch()
  const params = useParams()
  const { t } = useTranslation()
  const [avatar, setAvatar] = useState("")
  const [listRole, setListRole] = useState([])
  const [listRegional, setLitRegional] = useState([])
  const [listSubRegional, setListSubRegional] = useState(undefined)
  const [listSubRegionalLoading, setListSubRegionalLoading] = useState(true)
  const [listBase, setListBase] = useState([])
  const [selectedRegional, setSelectedRegional] = useState(formValues["regional"])
  const [selectedRole, setSelectedRole] = useState(formValues["roleFO"])
  const [selectedSubRegional, setSelectedSubRegional] = useState(formValues["subRegional"])

  function onChangeAvatar(e) {
    dispatch(uploadAction({ data: e, type: FO_UPLOAD_ENUM.AVATAR }))
  }

  useEffect(() => {
    if (selectedRegional) {      
      if (
        formValues["roleFO"] === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
        formValues["roleFO"] === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
      ) {
        dispatch(getListSubRegionalByRole(selectedRegional, formValues["roleFO"]))
      } else {
        dispatch(getDetailRegional(selectedRegional))
      }
    }
  }, [selectedRegional, formValues["roleFO"]])

  useEffect(() => {
    if (formValues["roleFO"] === "") return
    if (formValues["subRegional"]?.length > 0) {
      if (
        !(formValues["roleFO"] === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
          formValues["roleFO"] === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
        )
      ) {
        dispatch(getListBaseBySubRegional(formValues["subRegional"][0]))
      }
    } else {
      // Reset base field when subRegional is cleared
      setFieldValue("base", "")
      setListBase([])
    }
  }, [formValues["subRegional"], formValues["roleFO"]])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (MasterData.uploadType === FO_UPLOAD_ENUM.AVATAR) {
        setAvatar(MasterData.urlResponseUpload)
      }
    }
    return () => {
      dispatch(resetUrlResponse())
    }
  }, [MasterData.urlResponseUpload])

  useEffect(() => {
    if (formValues.avatar) {
      if (MasterData.urlResponseUpload === "") {
        formValues.avatar = ""
      }
    }
  }, [MasterData.uploadType, MasterData.urlResponseUpload])

  function onChangeRole(value) {
    setSelectedRole(value || "")

    setSelectedRegional("")
    if (selectedSubRegional.length > 0) setSelectedSubRegional([])
    setListSubRegional(undefined)
    setListSubRegionalLoading(true)

    setFieldValue("regional", "")
    setFieldValue("regionalHead", "")
    setFieldValue("regionalHead", "")
    setFieldValue("subRegional", [])
    setFieldValue("base", "")
    setFieldValue("fieldManager", "")
    setFieldValue("fieldSupervisor", "")
    setFieldValue("subRegionalByFm", "")
  }

  useEffect(() => {
    if (FieldOfficer?.role && FieldOfficer?.role?.length > 0) {
      setListRole([
        ...FieldOfficer.role.map((value) => {
          return {
            label: value?.display_name,
            value: value?.name
          }
        })
      ])
    }
  }, [FieldOfficer?.role])

  useEffect(() => {
    if (MasterData?.listRegionalAll) {
      setLitRegional(
        MasterData.listRegionalAll.map((item) => {
          return {
            label: item.name,
            value: item.id
          }
        })
      )
    }
  }, [MasterData?.listRegionalAll])

  useEffect(() => {
    if (MasterData?.listBaseBySubRegional) {
      setListBase(
        MasterData?.listBaseBySubRegional.map((item) => {
          return {
            label: item.name,
            value: item.id
          }
        }
        )
      )
    }
  }, [MasterData?.listBaseBySubRegional])

  useEffect(() => {
    if (
      user?.role === ROLE_ENUM.SUPER_ADMIN ||
      user?.role === ROLE_ENUM.ADMIN ||
      user?.role === ROLE_ENUM.OPS_ADMIN
    ) {
      if (
        selectedRole === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD ||
        selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
        selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
        selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
        selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
        selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
      ) {
        if (Array.isArray(listRegional) && listRegional.length > 0) {
          if (user?.regional_name) {
            let regionalName = user?.regional_name
            if (params?.id) {
              if (FieldOfficer?.detail?.regional_name) {
                regionalName = FieldOfficer?.detail.regional_name
              }
            }
            setSelectedRegional(
              (listRegional || []).find((item) => item.label === regionalName)?.value ?? ""
            )
            setFieldValue(
              "regional",
              (listRegional || []).find((item) => item.label === regionalName)?.value ?? ""
            )
          }
        }
      }
    }
  }, [listRegional, selectedRole])

  useEffect(() => {
    if (
      selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
      selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
      selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV
    ) {
      if (MasterData?.detailRegional) {
        setListSubRegional(
          MasterData.detailRegional.list_sub_regional.map((item) => {
            return {
              label: item.name,
              value: item.id,
              description: stringFormatting(item.regency_list)
            }
          })
        )
        setListSubRegionalLoading(false)
      }
    }
  }, [MasterData?.detailRegional, selectedRole])

  useEffect(() => {
    if (
      formValues["roleFO"] === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
      formValues["roleFO"] === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
    ) {
      if (MasterData?.listSubRegionalByRole) {
        const listSubregionalToSelectableItem = (datas) =>
          (datas ?? []).map((item) => {
            return {
              label: item.name,
              value: item.id,
              description: item.regency_list ?? null
            }
          })
        const dataListSubregionalByRole = listSubregionalToSelectableItem(
          MasterData?.listSubRegionalByRole
        )
        const shouldIncludeOriginalSubregionals =
          params?.id &&
          Array.isArray(FieldOfficer?.detail?.sub_regional_list) &&
          FieldOfficer?.detail?.sub_regional_list.length > 0
        setListSubRegional(
          params?.id && shouldIncludeOriginalSubregionals
            ? [
              ...listSubregionalToSelectableItem(FieldOfficer?.detail?.sub_regional_list),
              ...dataListSubregionalByRole
            ]
            : dataListSubregionalByRole
        )
        if (Array.isArray(listSubRegional)) setListSubRegionalLoading(false)
        if (params?.id && formValues["subRegional"].length === 0) {
          const subRegionalList = FieldOfficer?.detail?.sub_regional_list || []
          const selectedSubRegionalValues = subRegionalList.map((item) => item.id)
          setFieldValue("subRegional", selectedSubRegionalValues)
        }
      }
    }
  }, [MasterData?.listSubRegionalByRole, formValues["roleFO"], FieldOfficer?.detail?.sub_regional_list])

  useEffect(() => {
    if (formValues.hasOwnProperty("roleFO")) {
      setSelectedRole(formValues["roleFO"])
    }
  }, [formValues["roleFO"]])

  useEffect(() => {
    if (formValues.hasOwnProperty("subRegional")) {
      setSelectedSubRegional(formValues["subRegional"])
    }
  }, [formValues["subRegional"]])

  const prevRegionalRef = useRef(formValues["regional"])

  useEffect(() => {
    const currentRegional = formValues["regional"]
    const hasSubRegional = Array.isArray(formValues["subRegional"]) && formValues["subRegional"].length > 0
    const hasBase = formValues["base"] && formValues["base"] !== ""

    if (prevRegionalRef.current !== currentRegional) {
      const shouldClear =
        prevRegionalRef.current !== "" &&
        prevRegionalRef.current !== undefined &&
        (hasSubRegional || hasBase)

      if (shouldClear) {
        setFieldValue("subRegional", [])
        setFieldValue("base", "")
        setSelectedSubRegional([])
      }
      setSelectedRegional(currentRegional || "")
      prevRegionalRef.current = currentRegional
    }
  }, [formValues["regional"], formValues["subRegional"], formValues["base"]])

  const placeholder = <UploadIcon />

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("messages_title_detail_ops_team").toUpperCase()} />
        <CardBody>
          <RowModule>
            <UploadComponent
              urlParsing={avatar}
              label={t("label_profile_picture")}
              name="avatar"
              editable={!isReadOnly}
              onChange={onChangeAvatar}
              placeholder={placeholder}
            />
          </RowModule>
          <RowModule>
            <TextInput
              required
              onKeyDown={onKeyDown}
              editable={!isReadOnly}
              label={t("label_name")}
              name="name"
              placeholder={t("placeholder_input_name")}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name="roleFO"
              required
              editable={params?.id ? user?.role === ROLE_ENUM.SUPER_ADMIN : true}
              label={t("label_role")}
              placeholder={t("placeholder_select_operational_team")}
              options={listRole}
              onChange={(value) => onChangeRole(value)}
              chooseOptionWithLabel={false}
              value={selectedRole}
              isClearable={true}
            />
          </RowModule>
          {(selectedRole === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR) && (
              <RowModule>
                <SelectInput
                  name="regional"
                  required={
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
                  }
                  editable={true}
                  label={t("label_regional")}
                  placeholder={t("placeholder_select_or_type_regional")}
                  options={listRegional}
                  chooseOptionWithLabel={false}
                  value={selectedRegional}
                />
              </RowModule>
            )}
          {(selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV) ? (
            <RowModule>
              <TextFieldAutoComplete
                name={"subRegional"}
                editable={!listSubRegionalLoading && formValues?.regional !== ""}
                label={t("label_sub_regional")}
                placeholder={t("placeholder_select_sub_regional")}
                options={listSubRegional}
                value={formValues?.subRegional}
                alignItems={"start"}
                required={
                  selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                  selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                  selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
                  selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
                  selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
                }
                isMulti={
                  !(
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
                    selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
                  )
                }
              />
            </RowModule>
          ) : null}
          {(selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
            selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV
          ) &&
            Array.isArray(formValues?.subRegional) && (
              !General?.loadingComponent ? (
                <RowModule>
                  <SelectInput
                    name={"base"}
                    editable={Array.isArray(formValues?.subRegional) && formValues?.subRegional.length > 0}
                    label={t("sub_header_base")}
                    placeholder={t("choose_base")}
                    options={listBase}
                    value={formValues?.base}
                    alignItems={"start"}
                    required={
                      selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                      selectedRole === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                      selectedRole === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV
                    }
                  />
                </RowModule>
              ) : (
                <div className={"mb-3"}>
                  <Skeleton variant="text" width={200} height={20} />
                  <Skeleton variant="rect" width={"100%"} height={48} />
                </div>
              )
            )}

          <RowModule>
            <TextInput
              required
              editable={!isReadOnly}
              type="text"
              label={t("label_phone_number")}
              name="phone"
              placeholder={t("placeholder_input_phone_number")}
            />
          </RowModule>
          <RowModule>
            <TextInput
              required
              editable={!isReadOnly}
              label={t("label_email")}
              name="email"
              placeholder={t("placeholder_input_email_address")}
            />
          </RowModule>
        </CardBody>
      </Card>
      <AddressMolecule
        byRegional={!!user?.regional_id}
        regionalId={!!user?.regional_id}
        isChangeRegional={!!user?.regional_id}
        name="fo"
        isReadOnly={isReadOnly}
        addressTitle={t("label_operational_team_address").toUpperCase()}
      />
    </>
  )
}